export function getAWSEnvironment() {
  if (['production', 'prodstage'].includes(process.env.ENVIRONMENT)) {
    return 'sso';
  } else if (
    ['localhost', 'development', 'stage'].includes(process.env.ENVIRONMENT)
  ) {
    return 'dev';
  } else if (process.env.ENVIRONMENT === 'etsNext') {
    return 'etsNext';
  } else {
    throw new Error('Invalid environment supplied. No AWS environment found.');
  }
}

export function getAWSRegion() {
  const awsEnvironment = getAWSEnvironment();

  if (awsEnvironment === 'sso') {
    return 'us-east-1';
  } else if (awsEnvironment === 'dev') {
    return 'us-east-2';
  } else if (awsEnvironment === 'etsNext') {
    return 'us-east-1';
  } else {
    throw new Error('Invalid environment supplied. No AWS region found.');
  }
}

export function getAWSCredentials() {
  const awsEnvironment = getAWSEnvironment();

  if (['sso', 'dev'].includes(awsEnvironment)) {
    return {
      credentials: {
        accessKeyId: process.env.AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.AWS_SECRET_ACCESS_KEY,
      },
    };
  } else if (awsEnvironment === 'etsNext') {
    return {};
  } else {
    throw new Error('Invalid environment supplied. No AWS credentials found.');
  }
}
